// Import model
import { FilterAiChatRequest } from '../models/FilterAiChatRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { AiChatCondition } from '../models/AiChatCondition';
import { AiChatFields } from '../models/AiChatFields';
import { AiChatIndexedFields } from '../models/AiChatIndexedFields';

// Import dependency serializers (for complex types)
import { AiChatConditionSerializer } from './AiChatConditionSerializer';
import { AiChatFieldsSerializer } from './AiChatFieldsSerializer';
import { AiChatIndexedFieldsSerializer } from './AiChatIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterAiChatRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterAiChatRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterAiChatRequest instance
   */
  static deserialize(json: string): FilterAiChatRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterAiChatRequest instance
   */
  static fromObject(obj: any): FilterAiChatRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterAiChatRequest');
    }


    const instance: FilterAiChatRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as AiChatIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as AiChatFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        AiChatConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterAiChatRequest instances
   */
  static deserializeArray(json: string): FilterAiChatRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterAiChatRequest instance to a JSON string
   */
  static serialize(instance: FilterAiChatRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterAiChatRequest instance to a plain object
   */
  static toObject(instance: FilterAiChatRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        AiChatConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterAiChatRequest instances to a JSON string
   */
  static serializeArray(instances: FilterAiChatRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
